import { filter, find, isNil } from 'lodash-es'
import { object, string, number, array, mixed } from 'yup'
import { positionOnDomainWithinInterval } from './utils'

interface ConnectorListValidationContext {
  stiffeningElements: StiffeningSegment[]
  domains: Domain[]
  walls: ShapeObject[]
}

const OUTSIDE_EDGE_MESSAGE = 'Darf nicht außerhalb der Kante liegen'

export const connectorListSchema = object({
  targets: array().of(
    object({
      guid: string(),
      // Foundation targets come without a factor (and have no field for it)
      transmission_factor: number().min(0, 'Darf nicht kleiner 0 sein').when('target_type', {
        is: 'foundation',
        then: number().notRequired(),
        otherwise: number().required(),
      }),
      // Only wall targets have an editable position, other targets may come without one.
      // `mixed` instead of `number`: the resolver submits the cast values, and casting would turn
      // the exact decimal string from the server into a float, e.g. 3.55 m into 3.5499… that the
      // backend no longer matches to its stiffening interval
      relative_position: mixed<string | number | null>()
        .test({
          name: 'number',
          message: 'Wert muss eine Zahl sein',
          test: value => isNil(value) || (value !== '' && !Number.isNaN(Number(value))),
        })
        .test({
          name: 'on-edge',
          message: OUTSIDE_EDGE_MESSAGE,
          test: value => isNil(value) || (Number(value) >= 0 && Number(value) <= 1),
        })
        .test({
          name: 'inside-stiffening',
          message: 'Muss auf einem aussteifenden Element liegen',
          test: function (value) {
            const { stiffeningElements, domains, walls } =
              (this.options.context as ConnectorListValidationContext) || {}

            const wall = find(walls, ['guid', this.parent.element_guid]) as ShapeObject
            if (!wall) return true

            if (!stiffeningElements || !domains || isNil(value) || value === '') return false

            return positionOnDomainWithinInterval(
              wall,
              filter(stiffeningElements, ['element_guid', this.parent.element_guid]),
              Number(value),
            )
          },
        }),
    }),
  ),
})
